const getSamples = file => {
  const filesize = file.size
  const parts = []
  if (filesize < 50 * 1024 * 1024) parts.push(file)
  else {
    let total = 100
    const sampleSize = 1024 * 1024
    const chunkSize = Math.floor(filesize / total)
    let start = 0
    let end = sampleSize
    while (total > 1) {
      parts.push(file.slice(start, end))
      start += chunkSize
      end += chunkSize
      total--
    }
  }
  return parts
}

const failMsg = { status: false, message: 'message.error.failedToReadFile' }

const isUtf8 = (filePart) => {
  return new Promise(resolve => {
    const fileReader = new FileReader()
    fileReader.readAsText(filePart)

    fileReader.onload = (e) => {
      const str = e.target?.result
      // 大致取一半
      const sampleStr = str?.slice(4, 4 + str?.length / 2)
      if (sampleStr.indexOf('�') === -1) resolve({ status: true, type: 'utf8' })
      else resolve({ status: true, type: 'big5' })
    }
    fileReader.onerror = () => resolve(failMsg)
  })
}

export default async function (file) {
  const samples = getSamples(file)
  let res = failMsg

  for (const filePart of samples) {
    try {
      res = await isUtf8(filePart)
      if (res.type === 'big5') break
    } catch (error) {
      res = failMsg
      break
    }
  }
  return res
}
